import Homepage from "@/modules/Home";
import Backtest from "@/modules/Backtest";
import Login from "@/modules/Auth/Login";
import Register from "@/modules/Auth/Register";

export const login: ModuleRoute = {
  title: "Login",
  component: Login,
  path: "/login",
  exact: true
};

export const register: ModuleRoute = {
  title: "Register",
  component: Register,
  path: "/register",
  exact: true
};

export const home: ModuleRoute = {
  title: "Home",
  component: Homepage,
  path: "/",
  exact: true
};

export const backtest: ModuleRoute = {
  title: "Backtest",
  component: Backtest,
  path: "/backtest",
  exact: true
};
